import * as React from 'react';
import { st, classes } from './CoreDropdownContent.st.css';
import { CoreDropdownOption } from '../CoreDropdownOption';
const NOT_HOVERED_INDEX = -1;
export const DATA_HOOKS = {
    dropdownContent: 'dropdown-content',
    optionsContainer: 'dropdown-content-options-container',
    dropdownContentOption: 'dropdown-content-option',
};
/**
 * DropdownContent
 */
export class CoreDropdownContent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.optionsContainerRef = null;
        this.mouseCoords = { screenX: -1, screenY: -1 };
        this.state = { hoveredIndex: NOT_HOVERED_INDEX };
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onOptionHover = this.onOptionHover.bind(this);
    }
    componentDidMount() {
        if (this.props.selectedId || this.props.selectedId === 0) {
            const selectedIndex = this.props.options.findIndex((option) => option.id === this.props.selectedId);
            if (selectedIndex > -1) {
                const selectedOption = this.optionsContainerRef.childNodes[selectedIndex];
                const parentRect = this.optionsContainerRef.getBoundingClientRect();
                const selectedRect = selectedOption.getBoundingClientRect();
                if (selectedRect.bottom > parentRect.bottom) {
                    this.optionsContainerRef.scrollTop = Math.min(selectedOption.offsetTop +
                        selectedOption.clientHeight / 2 -
                        this.optionsContainerRef.offsetHeight / 2, this.optionsContainerRef.scrollHeight);
                }
                this.setHoveredIndex(selectedIndex);
            }
        }
    }
    setHoveredIndex(index) {
        if (this.state.hoveredIndex !== index) {
            this.setState({
                hoveredIndex: index,
            }, this.onOptionHover);
        }
    }
    onOptionHover() {
        if (this.props.onOptionHover) {
            this.props.onOptionHover(this.getSelectedOption());
        }
    }
    isValidOptionForSelection(option) {
        return option.isSelectable && !option.isDisabled;
    }
    scrollHoveredIntoView(hoveredIndex) {
        const hoveredOption = this.optionsContainerRef.childNodes[hoveredIndex];
        const hoveredOptionHeight = hoveredOption.offsetHeight;
        const hoveredOptionTop = hoveredOption.offsetTop - 1;
        const { scrollTop: optionsContainerScrollTop, clientHeight: optionsContainerClientHeight, } = this.optionsContainerRef;
        // If hovered option is not visible
        if (!(optionsContainerScrollTop <= hoveredOptionTop &&
            optionsContainerScrollTop + optionsContainerClientHeight >
                hoveredOptionTop + hoveredOptionHeight)) {
            if (this.optionsContainerRef.scrollTop < hoveredOptionTop) {
                this.optionsContainerRef.scrollTop =
                    hoveredOptionHeight + hoveredOptionTop - optionsContainerClientHeight;
            }
            else {
                this.optionsContainerRef.scrollTop = hoveredOptionTop;
            }
        }
    }
    hoverNextItem(interval) {
        const { options } = this.props;
        if (!options.find(this.isValidOptionForSelection)) {
            return;
        }
        let { hoveredIndex } = this.state;
        // eslint-disable-next-line no-constant-condition
        while (true) {
            hoveredIndex += interval;
            if (hoveredIndex === options.length) {
                hoveredIndex = 0;
            }
            else if (hoveredIndex < 0) {
                hoveredIndex = options.length - 1;
            }
            if (this.isValidOptionForSelection(options[hoveredIndex])) {
                break;
            }
        }
        this.setHoveredIndex(hoveredIndex);
        this.scrollHoveredIntoView(hoveredIndex);
    }
    getOptionDOMid(option) {
        const id = this.props.id;
        return id ? `${id}_option-${option.id}` : null;
    }
    getSelectedOption() {
        const { options } = this.props;
        const { hoveredIndex } = this.state;
        const isValidIndex = hoveredIndex >= 0 && hoveredIndex < options.length;
        return isValidIndex
            ? {
                ...options[hoveredIndex],
                _DOMid: this.getOptionDOMid(options[hoveredIndex]),
            }
            : null;
    }
    onMouseMove(evt) {
        this.mouseCoords.screenX = evt.screenX;
        this.mouseCoords.screenY = evt.screenY;
    }
    onMouseDown(e) {
        const { onMouseDown } = this.props;
        onMouseDown && onMouseDown(e);
    }
    onMouseEnter(evt, index) {
        if (this.mouseCoords.screenX !== evt.screenX ||
            this.mouseCoords.screenY !== evt.screenY) {
            this.setHoveredIndex(index);
        }
    }
    render() {
        const { fixedHeader, fixedFooter, options, selectedId, onOptionClick, id, className, role, activeDescendant, } = this.props;
        const { hoveredIndex } = this.state;
        return (React.createElement("div", { className: st(classes.root, className), "data-hook": DATA_HOOKS.dropdownContent, onMouseMove: this.onMouseMove, onMouseDown: this.onMouseDown },
            fixedHeader,
            React.createElement("div", { role: role, className: classes.optionsContainer, id: id, ref: (optionsContainer) => (this.optionsContainerRef = optionsContainer), tabIndex: -1, "data-hook": DATA_HOOKS.optionsContainer, ...(activeDescendant
                    ? { 'aria-activedescendant': activeDescendant }
                    : {}) }, (options || []).map((option, index) => (React.createElement(CoreDropdownOption, { className: classes.dropdownOption, dataHook: DATA_HOOKS.dropdownContentOption, key: option.id, id: this.getOptionDOMid(option), option: option, unavailable: option.unavailable, isHovered: hoveredIndex === index, isSelected: selectedId === option.id, onClickHandler: this.isValidOptionForSelection(option)
                    ? () => onOptionClick(option)
                    : undefined, onMouseEnterHandler: this.isValidOptionForSelection(option)
                    ? (evt) => this.onMouseEnter(evt, index)
                    : undefined, onMouseLeaveHandler: () => {
                    this.setHoveredIndex(NOT_HOVERED_INDEX);
                } })))),
            fixedFooter));
    }
}
CoreDropdownContent.displayName = 'CoreDropdownContent';
//# sourceMappingURL=CoreDropdownContent.js.map